import React from "react";

import { find } from "lodash";

import * as skill_details from "../data/skill_details.json";

const SkillDetails = ({ selectedSkill, dispatch }) => {
    if (selectedSkill == null) return <React.Fragment />;

    let skills = skill_details.default;

    let selected_skill = find(skills, { skill_tag: selectedSkill });
    if (!selected_skill) return <React.Fragment />;

    return (
        <div className="container skill-details">
            <div className="row">
                <div className="col">
                    {selected_skill.skill_desc.map((block, i) => (
                        <React.Fragment key={`skill-info_${i}`}>
                            <div className="row skill-head">{block.head}</div>
                            <div className="row skill-body">
                                <div
                                    className="col-sm"
                                    dangerouslySetInnerHTML={{
                                        __html: block.body,
                                    }}
                                />
                            </div>
                        </React.Fragment>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default SkillDetails;
